import { Text } from '@amo/core/components/forms';
import { RadioBlock } from '@amo/core/components/forms/RadioBlock/RadioBlock.jsx';
import { onError, validateEmail } from '@amo/core/utils/validateField';
import _ from 'lodash';
import { useEffect } from 'react';
import { Field } from 'redux-form';
import {getTranslation} from "@amo/core/utils/index.js";

const Email = (props) => {
    const { data, changeValue, emailParrainage } = props;
    // Consentements déjà recueillis à l'étape « Votre devis est presque prêt » : on ne repose pas les questions,
    // sauf la confirmation si l'e-mail a été modifié depuis
    const preferencesRecueillies = _.includes(['true', 'false', true, false], _.get(data, 'DemandeDevis[PixelConsent]'));
    const afficheConfirmation =
        !preferencesRecueillies || _.get(data, 'DemandeTarif[ListePersonnes][0][Email]') !== _.get(data, 'EmailValidation');

    useEffect(() => {
        changeValue(
            'emailOnError',
            _.get(data, 'DemandeTarif[ListePersonnes][0][Email]') &&
                _.get(data, 'EmailValidation') &&
                _.get(data, 'DemandeTarif[ListePersonnes][0][Email]') !== _.get(data, 'EmailValidation')
                ? 'onError'
                : null,
        );
    }, [_.get(data, 'DemandeTarif[ListePersonnes][0][Email]'), _.get(data, 'EmailValidation')]);

    return (
        <div>
            <div className={'row justify-content-center'}>
                <div className={'col-lg-8 col-md-6 col-sm-6 col-12 my-2'}>
                    <Field
                        label={getTranslation('coordonnees.email.addressMail')}
                        component={Text}
                        type={'email'}
                        typeFormat={'email'}
                        name={'DemandeTarif[ListePersonnes][0][Email]'}
                        validate={validateEmail}
                        onPaste={(e) => {
                            e.preventDefault();
                            return false;
                        }}
                        onCopy={(e) => {
                            e.preventDefault();
                            return false;
                        }}
                        required
                        autocomplete="email"
                        disabled={!!emailParrainage}
                    />
                    <small className={'text-start d-block'}>
                        {getTranslation(emailParrainage ? 'informationsSubscriptor.parrainageEmail' : 'informationsSubscriptor.informationEmail')}
                    </small>
                </div>
            </div>
            {afficheConfirmation && (
                <div className="row justify-content-center">
                    <div className={'col-lg-8 col-md-6 col-sm-6 col-12 my-2'}>
                        <Field component={Text} name={'emailOnError'} type={'hidden'} validate={onError}/>

                        {_.get(data, 'emailOnError') && _.get(data, 'emailOnError') === 'onError' && (
                            <small className="alert alert-danger invalid-feedback d-block">
                                {getTranslation('informationsSubscriptor.errorEmail')}
                            </small>
                        )}

                        <Field
                            label={getTranslation('informationsSubscriptor.confirmYourEmail')}
                            component={Text}
                            type={'email'}
                            typeFormat={'email'}
                            name={'EmailValidation'}
                            validate={validateEmail}
                            disabled={!!emailParrainage}
                            /*onPaste={(e) => {
                                e.preventDefault();
                                return false;
                            }}
                            onCopy={(e) => {
                                e.preventDefault();
                                return false;
                            }}*/
                            required
                        />
                    </div>
                </div>
            )}

            {!preferencesRecueillies && (
                <div className={'row justify-content-center mt-3'}>
                    <div className={'col-lg-8 col-md-6 col-sm-6 col-12 text-start'}>
                        <p><strong>Votre devis vous attend, ne le perdez pas !</strong></p>
                        <p className={'mb-4'}>Recevez vos informations directement par email</p>
                        <p><strong>Pourquoi recevoir vos relances de devis par email ?</strong></p>
                        <ul className={'list-unstyled'}>
                            <li className={'d-flex align-items-start mb-1'}>
                                <span className={'check-icon w-20 me-2 flex-shrink-0'} aria-hidden="true"/>
                                <span>Retrouvez votre devis à tout moment, même plusieurs jours après</span>
                            </li>
                            <li className={'d-flex align-items-start mb-1'}>
                                <span className={'check-icon w-20 me-2 flex-shrink-0'} aria-hidden="true"/>
                                <span>Des rappels utiles avant l&apos;expiration de votre tarif personnalisé</span>
                            </li>
                            <li className={'d-flex align-items-start mb-1'}>
                                <span className={'check-icon w-20 me-2 flex-shrink-0'} aria-hidden="true"/>
                                <span>Vos données sont protégées&nbsp;: aucun spam, désabonnement possible à tout moment</span>
                            </li>
                        </ul>

                        <Field
                            component={RadioBlock}
                            type={'radio'}
                            name={'DemandeDevis[EmailContactConsent]'}
                            value={'true'}
                            label={getTranslation("iAccept")}
                            className={'mb-2'}
                        />
                        <Field
                            component={RadioBlock}
                            type={'radio'}
                            name={'DemandeDevis[EmailContactConsent]'}
                            value={'false'}
                            label={getTranslation("iRefuse")}
                        />
                    </div>
                </div>
            )}
        </div>
    );
};

export default Email;
